import { I18n } from '@app/i18n/strings-keys';
import {
  IPdfDefinitions,
  IPdfData,
  PdfContentType,
  PdfContentSetting,
  IPdfColumn,
  getSearchHeaderDefine,
} from '@app/shared/common/make-pdf/v2';
import { getPluralEntityName } from '@app/shared/configs/entity-name-config';
import { ENTITY_TYPES } from '@app/shared/types/enums';
import { getSingleExportFileName } from '@app/shared/utils';
import { compact, get } from 'lodash';
import { ContentColumns, ContentText, Style } from 'pdfmake/interfaces';

const buildHistoricalQuantitiesPdfConfig = (
  data: IPdfDefinitions['data'],
  columns: IPdfColumn[],
  searched: boolean = false,
): IPdfDefinitions => ({
  data,
  generateFileName: (pdfData): string => {
    const headerPrefix = getPluralEntityName(
      ENTITY_TYPES.HISTORICAL_QUANTITIES,
    );
    const siteName: string = get(pdfData, 'site_name') as string;
    const printDate = get(pdfData, 'print_date') as string;

    return getSingleExportFileName(headerPrefix, siteName, printDate);
  },
  generateHeader: (
    pdfData: IPdfData,
    tools,
  ): (ContentText | ContentColumns)[] => {
    const { i18nService } = tools.services;

    return compact<ContentText | ContentColumns>([
      {
        text: i18nService.translate(
          I18n.EntityNames.HistoricalTransferQuantities,
        ),
        fontSize: 14,
        bold: true,
        margin: [20, 16, 20, 0],
      },
      {
        fontSize: 8,
        margin: [20, 5, 20, 0],
        columns: [
          {
            text: [
              {
                text: i18nService.translate(I18n.Forms.GridForm.SiteNameColon),
              },
              { text: get(pdfData, 'site_name', ''), bold: true },
            ],
          },
          {
            text: [
              { text: i18nService.translate(I18n.Forms.GridForm.SiteIDColon) },
              { text: get(pdfData, 'site_id', ''), bold: true },
            ],
          },
          {
            text: [
              {
                text: i18nService.translate(I18n.Forms.GridForm.EventTypeColon),
              },
              { text: get(pdfData, 'event_type', ''), bold: true },
            ],
          },
        ],
      },
      getSearchHeaderDefine(searched, pdfData, tools),
    ]);
  },
  content: {
    mainGrids: {
      type: PdfContentType.Grids,
      setting: (): PdfContentSetting => {
        return {
          data_list: {
            columns,
            headerRows: 2,
            title: {
              text: '',
              style: {
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 5],
              },
            },
            rowStyle: (): Style => {
              return {
                bold: false,
              };
            },
            columnDefaultStyle: {
              alignment: 'center',
              colSpan: 2,
              width: '*',
            },
          },
        };
      },
    },
  },
  options: {
    pageMargins: [20, searched ? 65 : 50, 20, 60],
  },
});

export { buildHistoricalQuantitiesPdfConfig };
